<template>
    <m-block-form-fields child :required="false">
        <template #title>
            {{$t('modules.blocks.forms.m-block-form-object-contacts.title')}}
        </template>

        <v-layout wrap>
            <v-flex xs12>
                <e-input-object-contact  v-model="$attrs.form.contact"/>
            </v-flex>

            <v-flex xs12>
                <e-input-object-extra-contact v-model="$attrs.form.extraContact"/>
            </v-flex>
        </v-layout>

        <v-layout justify-space-between>
            <v-flex xs3 md4>
                <e-input-select-object-contact-type v-model="$attrs.form.phoneNumber.type"/>
            </v-flex>
            <v-flex xs5 md8>
                <e-input-object-phone v-model="$attrs.form.phoneNumber.value"
                                      name="phoneNumber"
                                      rules="phone"
                />
            </v-flex>
        </v-layout>

        <v-layout justify-space-between>
            <v-flex xs3 md4>
                <e-input-select-object-contact-type v-model="$attrs.form.mobileNumber.type"/>
            </v-flex>
            <v-flex xs5 md8>
                <e-input-object-phone v-model="$attrs.form.mobileNumber.value"
                                      name="mobileNumber"
                                      rules="mobile"
                                      :label="$t('elements.inputs.e-input-object-phone-mobile.label')"/>
            </v-flex>
        </v-layout>

        <v-layout justify-space-between>
            <v-flex xs3 md4>
                <e-input-select-object-contact-type v-model="$attrs.form.email.type"/>
            </v-flex>
            <v-flex xs5 md8>
                <e-input-object-email v-model="$attrs.form.email.value"
                                      :label="$t('elements.inputs.e-input-object-email.label')"/>
            </v-flex>
        </v-layout>
    </m-block-form-fields>
</template>

<script>
    import MBlockFormFields from "@modules/blocks/form/m-block-form-fields";

    export default {
        name: "m-block-form-object-contacts",
        inject: ['$validator'],
        components: {MBlockFormFields}
    }
</script>

<style scoped>

</style>
